import script from "./Category.vue?vue&type=script&lang=ts&setup=true"
export * from "./Category.vue?vue&type=script&lang=ts&setup=true"

import "./Category.vue?vue&type=style&index=0&id=6bdef2ec&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bdef2ec"]])

export default __exports__